import { SectionPace, formatDuration } from '@/lib/actModes'
import { cn } from '@/lib/utils'

/**
 * How close his real pace is to each section's clock. The bar fills toward test
 * pace and turns green when he's under it -- the one number that decides
 * whether the section gets finished at all.
 */
export default function ActPaceTable({ pace }: { pace: SectionPace[] }) {
  return (
    <div className="space-y-3">
      {pace.map(row => {
        const avg = row.avgSecondsPerQuestion
        const ratio = avg != null ? avg / row.testSecondsPerQuestion : null
        const onPace = ratio != null && ratio <= 1
        return (
          <div key={row.section} className="border border-border rounded-xl p-3 space-y-1.5">
            <div className="flex items-baseline justify-between gap-3">
              <p className="text-sm font-medium">{row.label}</p>
              <p className="text-sm tabular-nums shrink-0">
                {avg != null ? (
                  <>
                    <span className={cn('font-bold', onPace ? 'text-green-600' : 'text-amber-600')}>
                      {formatDuration(avg)}
                    </span>
                    <span className="text-muted-foreground"> vs {formatDuration(row.testSecondsPerQuestion)}</span>
                  </>
                ) : (
                  <span className="text-muted-foreground">no questions yet</span>
                )}
              </p>
            </div>
            <div className="relative h-2 rounded-full bg-accent overflow-hidden">
              <div
                className={cn('h-full', onPace ? 'bg-green-500' : 'bg-amber-500')}
                style={{ width: `${Math.min(100, Math.round((ratio ?? 0) * 100))}%` }}
              />
            </div>
            <p className="text-[11px] text-muted-foreground">
              {row.questions} questions in {row.minutes} min
              {row.sampleQuestions > 0 && ` · ${row.sampleQuestions} logged`}
            </p>
          </div>
        )
      })}
    </div>
  )
}
